import React from "react"
import { Link } from "react-router-dom"
import { Navigation, Pagination, Autoplay, A11y } from "swiper"

import { Swiper, SwiperSlide } from "swiper/react"
import PubSub from "pubsub-js"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"

import "../../style/extra.scss"

function HomeContentText({ contentList, requireLogin = false }) {
  const doubleContentList = (contentList) => {
    let ret = []
    for (let index = 0; index < contentList.length; index += 2) {
      const dContent = [contentList[index]]
      if (contentList[index + 1]) {
        dContent.push(contentList[index + 1])
      }
      ret.push(dContent)
    }
    return ret
  }
  
  const contentTag = (content) => {
    return (
      <Link
        className="col-lg-12 col-md-6 mb-3 d-block"
        to={`/read-inner/${content.id}`}
        key={content.id}
        onClick={handleClick}
      >
        <div className="banner-text-content">
          <h3>{content.name}</h3>
          <p className="banner-text_date"><span className="series-name">{content.seriesName}</span>{content.releaseDate}</p>
          <p className="banner-text_content">{content.description}</p>
        </div>
      </Link>
    )
  }

  const handleClick = (e) => {
    if (requireLogin) {
      e.preventDefault()
      PubSub.publish("REQUIRE_LOGIN", e.target.to)
    }
  }
  
  return (
    <Swiper
      className="banner-content"
      modules={[Navigation, Pagination, Autoplay, A11y]}
      spaceBetween={50}
      slidesPerView={1}
      loop={false}
      autoplay={false
        // {
        // delay: 10000,
        // disableOnInteraction: false,
        // }
      }
      pagination={{ clickable: true }}
      speed={800}
    >
      {doubleContentList(contentList).map((dContent) => (
        <SwiperSlide key={dContent[0].id}>
          <div className="row">{dContent.map((dc) => contentTag(dc))}</div>
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default HomeContentText
